import { errorNotifier, successNotifier } from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";
import { USER_TYPES } from "../../../utils/userRole";

const ADDED_TYPE_LABEL = {
  [USER_TYPES.ESTATE_MEMBER]: "Estate Member",
  [USER_TYPES.VTU_USER]: "General User",
};

export const signUp = async (payload, setLoading, setSignUpp) => {
  try {
    const { data } = await http.post(AUTH_ROUTES.REGISTER_USER, payload);
    setLoading(false);

    // The backend deliberately adds a second userType to an existing Ovend
    // identity instead of creating a duplicate account — surface that
    // clearly rather than the generic "Registration Successfull" copy.
    if (data?.user?.message === "Account type added") {
      const label = ADDED_TYPE_LABEL[payload.userType] || "New";
      successNotifier(
        `${label} access has been added to your existing Ovend account. Use the same email and password to sign in and switch between your available accounts.`,
      );
    } else {
      successNotifier("Registration Successfull");
    }
    setSignUpp("signin");
  } catch (e) {
    console.log("sign up error", e.response);
    setLoading(false);
    errorNotifier(e.response?.data?.errors?.[0]?.msg);
  }
};
